import { render, staticRenderFns } from "./originators.vue?vue&type=template&id=12ba06a2&scoped=true"
import script from "./originators.vue?vue&type=script&lang=js"
export * from "./originators.vue?vue&type=script&lang=js"
import style0 from "./originators.vue?vue&type=style&index=0&id=12ba06a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba06a2",
  null
  
)

export default component.exports